var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:!_vm.isAutoHide ? 'pannel-btn-padding' : ''},[_c('RaceTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }